import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { format, set } from "date-fns";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { Column } from "primereact/column";
import { QuickSubmission } from "./QuickSubmission";
import { ILogin, IPermissionProps } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { PaymentTerm, SubmissionType, TaxTerm } from "../../models/ConsultantMast";


interface IProps {
    setModal: (modal: { singleData: any, open: boolean }) => void,
    toast: any,
    reload: boolean,
    isQuickSubmission?: boolean,
    reqDetails?: any,
}

interface IConsultantHotList {
    consultant_ID?: number,
    consultant_Name?: string,
    consultant_Email_ID?: string,
    consultant_Home_No?: string,
    consultant_Job_Title?: string,
    skillCategoryID?: number,
    skillCategoryName?: string,
    visa_Status?: string,
    state_ID?: number,
    state_Name?: string,
    city_ID?: number,
    city_Name?: string,
    total_Experience?: number,
    availability?: string,
    hourly_Rate?: number,
    tax_Term?: string,
    payment_Term?: string,
    status?: string,
    faceToFaceInterview?: string,
    reLocation?: string,
    contact_Person_EmailID?: string,
    contact_Person_Name?: string,
    phone_No?: string,
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    degree?: string,
    university_Name?: string,
    passoutYear?: number,
    country_ID?: number,
    country_Name?: string,
    dob?: string,
    ssn?: number,
    linkedin?: string,
    submissionType?: string,
    annual_Salary?: number,
    createdBy?: number,
    updatedBy?: number,
    createdByName?: string,
    updatedByName?: string,
}

export const Table = (props: IProps) => {
    const [reload, setReload] = useState(false);
    const [filters, setFilters] = useState({} as any);
    const [submissionForm, setSubmissionForm] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IConsultantHotList>, loading: boolean });
    const [selectedConsultant, setSelectedConsultant] = useState<Array<IConsultantHotList>>([]);
    const [emailLoading, setEmailLoading] = useState(false);
    const dt = useRef<any>(null);

    const openNew = () => {
        props.setModal({ singleData: {}, open: true });
    }

    const hideDialog = () => {
        setSelectedConsultant([]);
        setSubmissionForm({ singleData: {}, open: false });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => setReload(!reload)} />
                <Button label="New" icon="pi pi-plus" className="p-button-success mr-2 my-2" onClick={openNew} />
            </React.Fragment>
        );
    }

    const quickSubmission = () => {
        if (selectedConsultant.length > 1) {
            props.toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Please select only one consultant for quick submission', life: 3000 });
        } else if (selectedConsultant.length === 1) {
            setSubmissionForm({ singleData: selectedConsultant[0], open: true });
        } else {
            props.toast.current?.show({ severity: 'warn', summary: 'Warning', detail: 'Please select at least one consultant', life: 3000 });
        }
    }

    const sendEmail = async () => {
        if (selectedConsultant.length > 0) {
            setEmailLoading(true);
            const body = { consultant_IDs: selectedConsultant.map((item) => item.consultant_ID) };
            const response = await Fetch("ConsultantHotList/sendReqEmail", "POST", body, `Req_ID=${props.reqDetails.req_ID}`, props.toast);
            if (response) {
                props.toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Email sent successfully', life: 3000 });
                setSelectedConsultant([]);
                setEmailLoading(false);
            } else setEmailLoading(false);
        } else {
            props.toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please select at least 1 consultant', life: 3000 });
        }
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Send Email" className="p-button-rounded p-button-info mr-2 w-10rem" loading={emailLoading} disabled={emailLoading} onClick={sendEmail} />
                {selectedConsultant.length === 1 && <Button label="Quick Submission" className="p-button-rounded p-button-success mr-2 my-2 w-25rem" onClick={quickSubmission} />}
            </React.Fragment>
        );
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        const response = await Fetch("ConsultantHotList", "GET", null, (props.reqDetails !== undefined && props.reqDetails.req_ID !== undefined) ? `req_ID=${props.reqDetails.req_ID}` : null, props.toast);
        if (response) {
            const data: Array<IConsultantHotList> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    };

    const action = (rowData: any) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" label="Edit" className="p-button-rounded p-button-text" onClick={() => props.setModal({ singleData: rowData, open: true })} />
                {/* <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => { }} /> */}
            </React.Fragment>
        );
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload, reload, filters]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format

    return (
        <>
            {props?.isQuickSubmission === undefined && <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>}
            {props?.isQuickSubmission === true && selectedConsultant.length > 0 && <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                resizableColumns
                dataKey="consultant_ID"
                header={<></>}
                loading={tableData.loading}
                selectionMode={'checkbox'}
                selection={selectedConsultant}
                onSelectionChange={(e) => {
                    const value = e.value as IConsultantHotList[];
                    setSelectedConsultant(value);
                }}
            >
                {props?.isQuickSubmission === true && <Column selectionMode="multiple" />}
                <Column field="consultant_Name" header="Consultant Name" style={{ minWidth: "10rem" }} />
                <Column field="consultant_Email_ID" header="Consultant Email" />
                <Column field="consultant_Home_No" header="Consultant Home No" />
                <Column field="consultant_Job_Title" header="Consultant Job Title" />
                <Column field="skillCategoryName" header="Skill Category Name" />
                <Column field="visa_Status" header="Visa" />
                <Column field="state_Name" header="State Name" />
                <Column field="city_Name" header="City Name" />
                <Column field="total_Experience" header="Total Experience" />
                <Column field="availability" header="Availability" />
                <Column field="hourly_Rate" header="Hourly Rate" />
                <Column field="tax_Term" header="Tax Term" body={(rowData: any) => <p>{rowData.tax_Term ? TaxTerm[rowData.tax_Term] : ""}</p>} />
                <Column field="payment_Term" header="Payment Term" body={(rowData: any) => <p>{rowData.payment_Term ? PaymentTerm[rowData.payment_Term] : ""}</p>} />
                <Column field="status" header="Status" />
                <Column field="faceToFaceInterview" header="F2F" body={(rowData: any) => <p>{rowData.faceToFaceInterview ? "Yes" : "No"}</p>} />
                <Column field="reLocation" header="ReLocation" />
                <Column field="contact_Person_EmailID" header="Contact Person Email" />
                <Column field="vendor_Company_Name" header="Vendor Company" />
                <Column field="degree" header="Degree" />
                <Column field="university_Name" header="University Name" />
                <Column field="passoutYear" header="Passout Year" />
                <Column field="country_Name" header="Country Name" />
                {/* <Column field="dob" header="DOB" body={(rowData: any) => {
                    let date;
                    if (rowData.dob) date = format(new Date(rowData.dob), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return <p>{date}</p>
                }} /> */}
                <Column field="dob" header="DOB" body={(rowData: any) => safeFormatDate(rowData.dob, "dd/MM/yyyy", DateFormat)} />
                <Column field="ssn" header="SSN" />
                <Column field="linkedin" header="Linkedin" />
                <Column field="submissionType" header="Submission Type" body={(rowData: any) => {
                    if (rowData.submissionType) return <p>{SubmissionType[rowData.submissionType]}</p>
                    else return <p></p>
                }} />
                <Column field="annual_Salary" header="Annual Salary" />
                <Column field="createdByName" header="Created By" />
                <Column field="updatedByName" header="Updated By" />
                {props?.isQuickSubmission === undefined && <Column field="" header="Action" body={action} />}
            </DataTable>
            {props?.isQuickSubmission === true && <QuickSubmission singleData={props.reqDetails} body={selectedConsultant[0]} open={submissionForm.open} hideDialog={hideDialog} toast={props.toast} />}
        </>
    );
}